import React, { useState } from 'react';

import {
  ClickableComponent,
  Flexbox,
  FontAwesomeIcon,
  Text,
} from '@schoolinks/ui-components';

import { arrayOf, bool, func, shape, string } from 'prop-types';

import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import Drawer from 'components/Common/Drawer';

import Radio from 'components/Common/Radio';
import SearchInput from 'components/Common/SearchInput';

import s from './TranslationDrawer.css';

const TranslationDrawer = ({
  isElementary,
  languageDrawerOpen,
  languageOptions,
  onChange,
  onClose,
  selectedLanguage,
}) => {
  const [searchText, setSearchText] = useState('');

  return (
    <Drawer hideCloseButton open={languageDrawerOpen} onClose={onClose}>
      {() => (
        <Flexbox flexDirection="column">
          <Flexbox
            className={s.titleContainer}
            justifyContent="center"
            alignItems="center"
          >
            <Text variant="h5">Select language</Text>
            <ClickableComponent
              onClick={onClose}
              aria-label="Close language selection drawer"
              className={s.closeButton}
            >
              <FontAwesomeIcon color="grayDark" icon={faXmark} size="2xl" />
            </ClickableComponent>
          </Flexbox>
          <Flexbox
            flexDirection="column"
            className={s.contentContainer}
            rowGap={2}
          >
            {!isElementary && (
              <SearchInput
                variant="pill"
                size="small"
                label="Search language"
                onChange={e => setSearchText(e.target.value)}
              />
            )}
            <Radio
              label="English"
              hasBorder
              value="en"
              onChange={e => onChange(e.target)}
              checked={selectedLanguage?.value === 'en'}
              removeOffset
            />
            {languageOptions
              .filter(lang => lang.value !== 'en')
              .filter(lang =>
                lang.label.toLowerCase().includes(searchText.toLowerCase()),
              )
              .map(option => (
                <Radio
                  key={option.value}
                  label={option.label}
                  hasBorder
                  value={option.value}
                  onChange={e => onChange(e.target)}
                  checked={selectedLanguage?.value === option.value}
                  removeOffset
                />
              ))}
          </Flexbox>
        </Flexbox>
      )}
    </Drawer>
  );
};

TranslationDrawer.propTypes = {
  isElementary: bool.isRequired,
  languageDrawerOpen: bool.isRequired,
  languageOptions: arrayOf(
    shape({
      value: string,
      label: string,
    }),
  ).isRequired,
  onChange: func.isRequired,
  onClose: func.isRequired,
  selectedLanguage: shape({}).isRequired,
};

export default TranslationDrawer;
